import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { KitService, KitDescriptionService, ToolService } from '../../../camtl.service';
import { Kit } from '../../../../../shared/model';
import { CgpTreeviewService } from '../../../../../shared/cgp-treeview/cgp-treeview.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { parseDate } from '@progress/kendo-angular-intl';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kits',
  templateUrl: './kits.component.html',
  // styleUrls: ['./kits.component.scss']
})
export class KitsComponent implements OnInit, OnDestroy {

  constructor(
    private service: KitService,
    private formBuilder: FormBuilder,
    private systemSelectService: SystemSelectService,
    private routeParams: ActivatedRoute,
    private kitDescriptionService: KitDescriptionService,
    private cgpTreeviewService: CgpTreeviewService,
    private assignedToolService: ToolService,
    private toolParentService: ToolService,
    public routeValidationService: RouteValidationService) { }

  systemLayout: string;
  editForm: FormGroup;
  editDataItem: Kit;
  system: any;
  kitId: string;
  dataSource: any;
  selected: any;
  parentId: any;

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    var self = this;

    this.editForm = this.formBuilder.group({
      Id: [],
      KitNumber: [],
      KitDescriptionId: [{ value: [] }, Validators.required],
      LeftCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      RightCount: [0, Validators.compose([Validators.required,])],
      SingleCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      TotalHours: [""],
      DesignEndDate: [new Date()],
      DockDate: [new Date()],
      Pcbom: [""],
      Integration: [false],
      WireDesign: [""],
      Cancelled: [false],
      CreatedBy: [],
      CreatedDate: [],
      SystemId: [""],
      ToolId: [""],
      SystemLayoutToolId: [""],
      JobNumber: []
    })

    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Kits')) {
          this.cgpTreeviewService.dataSource$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(dataSource => this.dataSource = dataSource);
          this.cgpTreeviewService.selected$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(selected => this.selected = selected);
          this.cgpTreeviewService.get();
          this.cgpTreeviewService.getSelected();
        }

        if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Kits')) {
          this.assignedToolService.read("/listview/" + this.system.Id, true).then(function (response: any) {
            var newResponse = response.filter(function (tool) {
              return tool.ToolTypeName === "Tool" || tool.ToolTypeName === "Furnished Equipment" || tool.ToolTypeName === "Legacy Tool";
            });

            for (var i = 0; i < newResponse.length; i++) {
              newResponse[i]["DisplayNumber"] = newResponse[i].ToolDetail.ToolNumber;
            }
            self.assignedToolService.data = newResponse;
          });

          if (this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
            this.template.controls.add = false;
            this.template.controls.edit = false;
            this.template.controls.delete = false;
          }
          else {
            this.template.controls.add = true;
            this.template.controls.edit = true;
            this.template.controls.delete = true;
          }
        }
      });

    this.systemSelectService.get();
    this.kitDescriptionService.query('?$filter=Status eq true');

    if (this.routeParams.snapshot.params["id"]) {
      this.kitId = this.routeParams.snapshot.params["id"];
    }

    this.routeParams.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        this.parentId = params["ParentId"];

        if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Kits') && this.parentId.includes('-')) {
          if (this.system) {
            this.assignedToolService.read("/assigned/" + this.parentId, true).then(function (response: any) {
              for (var i = 0; i < response.length; i++) {
                response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;
              }
            });
          }
          if (this.parentId) {
            this.toolParentService.read("/" + this.parentId, true).then(function (response) {
              self.systemLayout = response[0].ToolDetail.ToolNumber;
            })
          }
        }
      })

    this.changeTemplateService();
  }

  setUnassignedRed = (value) => {
    if (value === "N/A") {
      return 'cgp-red';
    }

    return '';
  }

  private columns: any[] = [
    {
      field: "KitNumber",
      title: "Kit Number",
    },
    {
      field: "KitDescriptionName",
      title: "Description"
    },
    {
      field: "TotalHours",
      title: "Total Hours",
      width: 125
    },
    {
      field: "DesignEndDate",
      title: "Design End Date",
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }
    },
    {
      field: "DockDate",
      title: "Dock Date",
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }
    },
    {
      field: 'LeftCount',
      title: 'LH',
      width: 70
    },
    {
      field: 'RightCount',
      title: 'RH',
      width: 70
    },
    {
      field: 'SingleCount',
      title: 'S',
      width: 70
    },
    {
      field: "Pcbom",
      title: "PCB",
      width: 80,
      template: {
        type: "customStyle",
        setClass: this.setUnassignedRed
      }
    },
    {
      field: "Integration",
      title: "INT",
      template: {
        type: "boolean",
        onLabel: "True",
        offLabel: "False"
      },
      width: 80
    },
    {
      field: "WireDesign",
      title: "WD",
      width: 80,
      template: {
        type: "customStyle",
        setClass: this.setUnassignedRed
      }
    },
    {
      field: "Canceled",
      title: "CAN",
      template: {
        type: "boolean",
        onLabel: "True",
        offLabel: "False"
      },
      width: 80
    }
  ];

  getById = () => {
    if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Kits')) {
      return this.service.read("/" + this.kitId, true).then(function (response) {
        if (response) {
          if (response.Pcbom === null || response.Pcbom === "") {
            response.Pcbom = "N/A";
          }
          if (response.WireDesign === null || response.WireDesign === "") {
            response.WireDesign = "N/A";
          }
          response["DesignEndDate"] = response["DesignEndDate"].toString().split("T")[0];
          response["DockDate"] = response["DockDate"].toString().split("T")[0];
          return [response];
        }

        return [];
      })
    }
  }

  getByParentId = () => {
    if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Kits') && this.parentId.includes('-')) {
      return this.service.read("/parent/" + this.parentId, true).then(function (response) {
        if (response.length) {
          response = response.filter(function (kit) {
            if (kit.Pcbom === null || kit.Pcbom === "") {
              kit.Pcbom = "N/A";
            }
            if (kit.WireDesign === null || kit.WireDesign === "") {
              kit.WireDesign = "N/A";
            }

            return kit;
          })

          for (var i = 0; i < response.length; i++) {
            if (response[i]["DesignEndDate"] !== null) {
              response[i]["DesignEndDate"] = response[i]["DesignEndDate"].toString().split("T")[0];
            }

            if (response[i]["DockDate"] !== null) {
              response[i]["DockDate"] = response[i]["DockDate"].toString().split("T")[0];
            }
          }
        }

        return response;

      })
    }
  }

  onSave = (dataItem, isNew) => {
    var self = this;
    this.service.save(dataItem, isNew, "", true, false).then(function () {
      self.grid.refresh(true);
    })
  }



  changeTemplateService() {
    if (this.kitId) {
      this.template = {
        controls: {
          add: false,
          edit: true,
          delete: true,
          excel: true
        },
        columns: this.columns,
        service: this.service,
        save: this.onSave,
        read: this.getById,
        fileName: "kits.xlsx",
        displayField: "KitNumber"
      }
    }
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
    },
    columns: this.columns,
    service: this.service,
    save: this.onSave,
    read: this.getByParentId,
    fileName: "kits.xlsx",
    displayField: "KitNumber"
  }

  private toolIdControl = {
    type: 'combobox',
    name: 'ToolId',
    title: 'Tool',
    placeholder: 'Select Tool',
    textField: 'DisplayNumber',
    valueField: 'Id',
    readonly: 'update',
    service: this.assignedToolService,
    sync: true
  };

  formDialog = {
    title: "Kit",
    formControls: [
      this.toolIdControl,
      {
        type: 'combobox',
        name: "KitDescriptionId",
        title: "Kit Description",
        placeholder: 'Select Kit Description',
        textField: "Name",
        valueField: "Id",
        service: this.kitDescriptionService
      },
      {
        type: 'number',
        name: 'LeftCount',
        title: 'LH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'RightCount',
        title: 'RH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'SingleCount',
        title: 'S',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'TotalHours',
        title: 'Total Hours',
        minimum: 0,
        step: 1
      },
      {
        type: 'date',
        name: 'DesignEndDate',
        title: 'Design End Date',
        format: 'MM/dd/yyyy'
      },
      {
        type: 'date',
        name: 'DockDate',
        title: 'Dock Date',
        format: 'MM/dd/yyyy'
      },
      {
        type: 'presetCombobox',
        name: 'Pcbom',
        title: 'PCB',
        placeholder: 'Select PCB',
        textField: 'value',
        valueField: 'value',
        data: [
          { "value": "True" },
          { "value": "False" },
        ]
      },
      {
        type: 'boolean',
        name: 'Integration',
        title: 'INT'
      },
      {
        type: 'presetCombobox',
        name: 'WireDesign',
        title: 'WD',
        placeholder: 'Select Wire Design',
        textField: 'value',
        valueField: 'value',
        data: [
          { "value": "True" },
          { "value": "False" }
        ]
      },
      {
        type: 'boolean',
        name: 'Cancelled',
        title: 'CAN'
      }
    ]
  }

  setModelHandler() {
    this.editDataItem = new Kit();

    this.editDataItem.Cancelled = false;
    this.editDataItem.Integration = false;
    this.editDataItem.SystemLayoutToolId = this.parentId;
    this.editDataItem.LeftCount = 0;
    this.editDataItem.RightCount = 0;
    this.editDataItem.SingleCount = 0;
    this.editDataItem.JobNumber = 0;

    if (this.system) {
      this.editDataItem.SystemId = this.system.Id;
    }
  }

  onEdit(object) {
    (object.dataItem.DesignEndDate && object.dataItem.DesignEndDate !== null) ? object.dataItem.DesignEndDate = parseDate(object.dataItem.DesignEndDate) : object.dataItem.DesignEndDate = new Date();
    (object.dataItem.DockDate && object.dataItem.DockDate !== null) ? object.dataItem.DockDate = parseDate(object.dataItem.DockDate) : object.dataItem.DockDate = new Date();

  }

}
